// Notes the coach writes from chat (backend coach/head/remember.py, 2026-10-19):
// a calendar note with author 'coach' and source_item_id = the athlete's message
// it came from. The athlete can edit (it becomes theirs) and delete it like
// their own. A coach reply lists what it kept as body.saved:
//   [{ where: 'note', id, start_date, end_date, text } | { where: 'notebook', id, kind, text, provenance }]
// Mirrored in mobile lib/v2/coach-notes.ts — keep the two in sync.

export const COACH_BADGE = 'Added by your coach';

export const isCoachNote = (note) => note?.author === 'coach';

const DAY = { weekday: 'short', day: 'numeric', month: 'short' };

/** "Thu 22 Oct" for an ISO date (a calendar day, not a moment). */
export function dayLabel(iso) {
  if (!iso) return '';
  const d = new Date(`${String(iso).slice(0, 10)}T00:00:00Z`);
  return Number.isNaN(d.getTime()) ? String(iso) : d.toLocaleDateString('en-GB', { ...DAY, timeZone: 'UTC' });
}

/** "Thu 22 Oct" or "Thu 22 – Sun 25 Oct". */
export function rangeLabel(start, end) {
  if (!end || end === start) return dayLabel(start);
  return `${dayLabel(start)} – ${dayLabel(end)}`;
}

/** The line under a coach note: "From your message on Mon 19 Oct" when the
 *  message is in the loaded thread, "From your chat message" when it isn't,
 *  null for a note with no source. `thread` is the store's {id: item}. */
export function noteSource(note, thread) {
  const ref = note?.source_item_id;
  if (!ref) return null;
  const msg = thread?.[ref];
  if (msg?.created_at) {
    const d = new Date(msg.created_at);
    if (!Number.isNaN(d.getTime())) return `From your message on ${d.toLocaleDateString('en-GB', DAY)}`;
  }
  return 'From your chat message';
}

/** The lines under a coach reply that kept something. */
export function savedLines(saved) {
  const list = Array.isArray(saved) ? saved : [];
  const notes = list.filter((s) => s?.where === 'note' && s.text);
  const book = list.filter((s) => s?.where === 'notebook' && s.text);
  const out = [];
  if (notes.length) {
    out.push(`Saved to your calendar: ${notes.map((n) => `${rangeLabel(n.start_date, n.end_date)}: ${n.text}`).join('; ')}`);
  }
  if (book.length) out.push(`Noted for later: ${book.map((n) => n.text).join('; ')}`);
  return out;
}
